var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"target-bars"},[_c('TargetBars',{attrs:{"height":250,"targetsData":_vm.targetsData,"currentData":_vm.realizedData,"labels":_vm.labels,"title":_vm.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }